export interface ActionBarButton {
  id: string;
  labelKey: string;
  onClick(): void;
  disabled?: boolean;
}

export interface ActionBarHandle {
  setButtons(buttons: readonly ActionBarButton[]): void;
  destroy(): void;
}

export interface ActionBarOptions {
  viewReset?: {
    labelKey: string;
    onResetView(): void;
  };
}

export function createActionBar(
  root: HTMLElement,
  initial: readonly ActionBarButton[],
  options: ActionBarOptions = {},
): ActionBarHandle {
  function render(buttons: readonly ActionBarButton[]): void {
    root.replaceChildren();
    const renderedButtons = options.viewReset
      ? [
          ...buttons,
          {
            id: 'view-reset',
            labelKey: options.viewReset.labelKey,
            onClick: () => options.viewReset?.onResetView(),
          },
        ]
      : buttons;
    for (const b of renderedButtons) {
      const btn = document.createElement('button');
      btn.className = 'fn-actionbar-btn';
      btn.textContent = b.labelKey;
      btn.dataset.actionId = b.id;
      if (b.disabled) btn.disabled = true;
      btn.addEventListener('click', () => b.onClick());
      root.appendChild(btn);
    }
  }
  render(initial);
  return {
    setButtons(next) {
      render(next);
    },
    destroy() {
      root.replaceChildren();
    },
  };
}
